<template>
  <div>
    <Filters
      :filters="offersFilters"
      filter-key="offers"
      :initial-data="filtersStatus.offers"
      :loading="filtersLoading"
    />

    <TableWrapper
      :table-columns="offersColumns"
      table-key="offers"
      row-key="tableId"
      lazy
      :load="getAnalyses"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
    />
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';

  import { offersFilters, offersColumns } from '@/config';
  import { offersApi } from '@/api';
  import abortControllerMixin from '@/mixins/abortControllerMixin';
  import filterLoadingMixin from '@/mixins/filterLoadingMixin';
  import Filters from '@/components/Filters.vue';
  import TableWrapper from '@/components/TableWrapper.vue';
  import axios from 'axios';

  export default {
    name: 'OffersIndex',
    components: {
      Filters,
      TableWrapper,
    },
    mixins: [abortControllerMixin, filterLoadingMixin],
    data() {
      return {
        offersFilters,
        offersColumns,
      };
    },
    computed: {
      ...mapGetters(['tableFilters', 'filtersStatus']),
    },
    methods: {
      ...mapActions([
        'updateTableRows',
        'updateTableCount',
        'parseQueryStringStatus',
      ]),
      async tableRows() {
        const signal = this.createAbortController();
        this.filtersLoading = true;
        let aborted = false;
        try {
          const offersIndex = await offersApi.index(
            this.tableFilters('offers'),
            this.filtersStatus.offers,
            { signal }
          );
          const offersCount = await offersApi.count(this.filtersStatus.offers, {
            signal,
          });

          const offers = offersIndex.data.map((offer) => ({
            tableId: `${offer.id}.${offer.docNumber}`,
            hasChildren: true,
            ...offer,
          }));

          this.updateTableRows({ tableKey: 'offers', rows: offers });
          this.updateTableCount({
            tableKey: 'offers',
            count: offersCount.data.count,
          });
        } catch (error) {
          if (axios.isCancel(error)) {
            aborted = true;
            return;
          }
          this.$notify({
            showClose: true,
            type: 'error',
            message: error.response.data.error.message,
          });
        } finally {
          if (!aborted) {
            this.filtersLoading = false;
          }
        }
      },
      async getAnalyses(tree, treeNode, resolve) {
        const offerItemsIndex = await offersApi.itemsIndex(tree.id);
        resolve(
          offerItemsIndex.data.map((offerItem) => ({
            tableId: `${offerItem.id}.${offerItem.offerId}`,
            customerName: tree.customerName,
            expirationDate: tree.expirationDate,
            issuedAtLocal: tree.issuedAtLocal,
            ...offerItem,
          }))
        );
      },
    },
    created() {
      this.parseQueryStringStatus(this.$route.query);
      this.tableRows();
    },
    beforeRouteUpdate(to, from, next) {
      this.parseQueryStringStatus(to.query);
      this.tableRows();
      next();
    },
  };
</script>
